import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SubjectAreaTargetObjectLookupData  {
    targetObjects: Array<DropdownOptionIntegerId>;
    platforms: Array<DropdownOptionIntegerId>;
    dataSets: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
